var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "Carousel",
        {
          attrs: {
            "per-page": 1,
            autoplay: true,
            loop: true,
            autoplayHoverPause: true,
            autoplayTimeout: 4000,
            paginationPadding: 3,
            paginationActiveColor: _vm.paginationActiveColor,
            paginationColor: _vm.paginationColor,
          },
        },
        _vm._l(_vm.banners, function (item, index) {
          return _c("Slide", { key: index }, [
            item.id.includes("banner-commerce-debut")
              ? _c(
                  "div",
                  {
                    staticClass: "clickable-banner",
                    on: {
                      click: function ($event) {
                        return _vm.handleCommerceBannerClick()
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "banner-img",
                      attrs: { src: item.image.url, loading: "lazy" },
                    }),
                  ]
                )
              : _c("a", { attrs: { href: item.link, target: item.link } }, [
                  _c("img", {
                    staticClass: "banner-img",
                    attrs: {
                      src: _vm.optimizeImage(`${item.image.url}?w=600`),
                      loading: "lazy",
                    },
                  }),
                ]),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }